import { IComponentLayout } from '../model';

import { ADDITIONAL_INFO_ROW_DISABLED_LAYOUT, ADDITIONAL_INFO_ROW_ENABLED_LAYOUT } from './additionalInfoRow';
import { DESCRIPTION_ROW_ICON_INFO, DESCRIPTION_ROW_DISABLED, DESCRIPTION_ROW_INFO } from './descriptionRow';
import {
  CUSTOM_TITLE_TITLE_PRICE_LAYOUT,
  TITLE_ICON_TITLE_LAYOUT,
  TITLE_ICON_TITLE_PRICE_LAYOUT,
  TITLE_TITLE_LAYOUT,
  TITLE_TITLE_PRICE_BUTTON_LAYOUT,
  TITLE_TITLE_PRICE_LAYOUT,
} from './titleRow';

export const ICON_TITLE_INFO_ADDITIONAL_INFO_LAYOUT: IComponentLayout = {
  firstRow: TITLE_ICON_TITLE_LAYOUT,
  secondRow: DESCRIPTION_ROW_ICON_INFO,
  thirdRow: ADDITIONAL_INFO_ROW_ENABLED_LAYOUT,
};

export const ICON_TITLE_PRICE_LAYOUT: IComponentLayout = {
  firstRow: TITLE_ICON_TITLE_PRICE_LAYOUT,
  secondRow: DESCRIPTION_ROW_DISABLED,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const ICON_TITLE_INFO_LAYOUT: IComponentLayout = {
  firstRow: TITLE_ICON_TITLE_LAYOUT,
  secondRow: DESCRIPTION_ROW_ICON_INFO,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const ICON_TITLE_PRICE_INFO_LAYOUT: IComponentLayout = {
  firstRow: TITLE_ICON_TITLE_PRICE_LAYOUT,
  secondRow: DESCRIPTION_ROW_ICON_INFO,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const ICON_TITLE_LAYOUT: IComponentLayout = {
  firstRow: TITLE_ICON_TITLE_LAYOUT,
  secondRow: DESCRIPTION_ROW_DISABLED,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const TITLE_PRICE_BUTTON_LAYOUT: IComponentLayout = {
  firstRow: TITLE_TITLE_PRICE_BUTTON_LAYOUT,
  secondRow: DESCRIPTION_ROW_DISABLED,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const TITLE_LAYOUT: IComponentLayout = {
  firstRow: TITLE_TITLE_LAYOUT,
  secondRow: DESCRIPTION_ROW_DISABLED,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const TITLE_INFO_PRICE_LAYOUT: IComponentLayout = {
  firstRow: TITLE_TITLE_PRICE_LAYOUT,
  secondRow: DESCRIPTION_ROW_INFO,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const TITLE_PRICE_LAYOUT: IComponentLayout = {
  firstRow: TITLE_TITLE_PRICE_LAYOUT,
  secondRow: DESCRIPTION_ROW_DISABLED,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

// exported custom layouts
export const CUSTOM_TITLE_PRICE_LAYOUT: IComponentLayout = {
  firstRow: CUSTOM_TITLE_TITLE_PRICE_LAYOUT,
  secondRow: DESCRIPTION_ROW_DISABLED,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};

export const CUSTOM_TITLE_INFO_PRICE_LAYOUT: IComponentLayout = {
  firstRow: TITLE_TITLE_PRICE_LAYOUT,
  secondRow: DESCRIPTION_ROW_INFO,
  thirdRow: ADDITIONAL_INFO_ROW_DISABLED_LAYOUT,
};
